import React from 'react'
import PropTypes from 'prop-types'

import { Table } from 'semantic-ui-react'

import TableHeaderCell from 'Components/TableHeaderCell'

const MySearchesTableHeader = ({ handleSort, sortBy, sortOrder }) => (
  <Table.Header>
    <Table.Row>
      <TableHeaderCell handleSort={handleSort} icon="tag" id="name" sortOrder={sortOrder} sorting={sortBy === 'name'} text="Name" />

      <TableHeaderCell
        handleSort={handleSort}
        icon="search"
        id="rugs"
        sortOrder={sortOrder}
        sorting={sortBy === 'rugs'}
        text="Number of results"
      />

      <TableHeaderCell
        handleSort={handleSort}
        icon="calendar"
        id="dateCreated"
        sortOrder={sortOrder}
        sorting={sortBy === 'dateCreated'}
        text="Saved Date"
      />

      <TableHeaderCell icon="trash" text="Delete Search" disabled />
    </Table.Row>
  </Table.Header>
)

MySearchesTableHeader.propTypes = {
  handleSort: PropTypes.func,
  sortBy: PropTypes.string.isRequired,
  sortOrder: PropTypes.string.isRequired,
}

export default MySearchesTableHeader
